import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppContext } from '@state/context'
import { closePanel } from '@state/actions/panelsActions'
import {
  PANELS,
  DIVIDER_SIZE,
  BUTTON_SIZE,
  HEADING_TYPE,
  BUTTON_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import Button from '@components/Button'
import ButtonWithLoader from '@components/ButtonWithLoader'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Divider from '@components/Divider'
import { useCurrentUser } from '@hooks/useCurrentUser'
import { useDisconnectCustomerSchoolClass } from '@hooks/mutations/useDisconnectCustomerSchoolClass'

const RemoveClassPanel = () => {
  const [state, dispatch] = useContext(AppContext)
  const {
    panels: { panelData: { classId, className } },
  } = state
  const { currentUser } = useCurrentUser()
  const navigate = useNavigate()
  const { post, isPosting } = useDisconnectCustomerSchoolClass()

  const doRemoveSchoolClass = async () => {
    const res = await post({
      disconnectSchoolClasses: [classId],
      id: currentUser.id,
    })

    if (res.success) {
      dispatch(closePanel(PANELS.REMOVE_SCHOOL_CLASS))
      navigate('/lararrum')
    }
  }

  return (
    <>
      <div className={'relative'}>
        <div className='absolute top-0 right-0'>
          <Button
            handleClick={() => {
              dispatch(closePanel(PANELS.REMOVE_SCHOOL_CLASS))
            }}
            size={BUTTON_SIZE.NO_PADDING}
            icon={'Close'}
          ></Button>
        </div>
      </div>

      {classId && className && (
        <div className={'flex flex-col items-center'}>
          <Text>{className}</Text>
          <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XLARGE}>
            Är du säker på att du vill dölja denna klass i ditt lärarrum? Böcker som du har delat med klassen kommer att försvinna för eleverna.
          </Heading>

          <Divider size={DIVIDER_SIZE.BASE} />

          <ButtonWithLoader
            type={BUTTON_TYPE.PRIMARY}
            isLoading={isPosting}
            disabledText={'Ja, dölj klass'}
            enabledText={'Ja, dölj klass'}
            disabled={isPosting}
            handleClick={() => {
              doRemoveSchoolClass()
            }}
          />

          <Divider size={DIVIDER_SIZE.SMALL} />

          <Button
            type={BUTTON_TYPE.SECONDARY}
            size={BUTTON_SIZE.LARGE}
            handleClick={() => {
              dispatch(closePanel(PANELS.REMOVE_SCHOOL_CLASS))
            }}
          >
            Avbryt
          </Button>
        </div>
      )}
    </>
  )
}

export default RemoveClassPanel
